import React, { useState, useEffect } from 'react';

import ExclusiveServices from "../components/ExclusiveServices";
import HeroSection from "../components/HeroSection";
import FooterSection from "../components/FooterSection";

function Index() {

    document.title = "Accueil || Barberlys"

    return (
        <div className="">
            <div id="accueil">
                <HeroSection />
            </div>
            <div id="services">
                <ExclusiveServices />
            </div>
            <div id="footer">
                <FooterSection />
            </div>
        </div>
    )
}

export default Index;